import { useMutation, useQuery } from '@tanstack/react-query';
import tenantUseCase from '../factories/tenants';

export const useGetAccount = (options = {}) =>
  useQuery({
    queryKey: ['get-account'],
    queryFn: () => tenantUseCase.getAccount(),
    ...options,
  });

export const useGetPayments = (tenantId, options = {}) =>
  useQuery({
    queryKey: ['get-payments', tenantId],
    queryFn: () => tenantUseCase.getPayments(tenantId),
    ...options,
  });

export const useDeleteAccount = () => useMutation(tenantUseCase.deleteAccount);

export const useConnectCustomDomain = () =>
  useMutation({
    mutationFn: (domain) => tenantUseCase.connectCustomDomain(domain),
  });

export const useCustomDomainStatus = (options = {}) =>
  useQuery({
    queryKey: ['custom-domain-status'],
    queryFn: () => tenantUseCase.getCustomDomainStatus(),
    refetchInterval: 30000, // Refetch every 30 seconds
    ...options,
  });

export const useVerifyCustomDomain = () =>
  useMutation({
    mutationFn: () => tenantUseCase.verifyCustomDomain(),
  });
